var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [_c("span", [_vm._v("等级配置管理")])]
          ),
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.loadConfig },
              model: {
                value: _vm.activeZone,
                callback: function ($$v) {
                  _vm.activeZone = $$v
                },
                expression: "activeZone",
              },
            },
            [
              _c("el-tab-pane", {
                attrs: { label: "企业活动专区", name: "1" },
              }),
              _c("el-tab-pane", {
                attrs: { label: "商家赋能专区", name: "2" },
              }),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.configLoading,
                  expression: "configLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.configList, size: "mini", border: "" },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "level", label: "等级", width: "80" },
              }),
              _c("el-table-column", {
                attrs: { prop: "levelName", label: "等级名称", width: "120" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "consumeThreshold",
                  label: "累计消费门槛(元)",
                  width: "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "bonusRate",
                  label: "直推奖比例(0.3300=33%)",
                  width: "130",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(scope.row.bonusRate))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "是否展示", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: scope.row.isShow ? "success" : "info",
                              size: "mini",
                            },
                          },
                          [_vm._v(_vm._s(scope.row.isShow ? "是" : "否"))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "sort", label: "排序", width: "80" },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["admin:kx:level:update"],
                                expression: "['admin:kx:level:update']",
                              },
                            ],
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEditConfig(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "编辑等级配置",
            visible: _vm.editDialogVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.editDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.editForm,
                "label-width": "140px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "等级名称" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.editForm.levelName,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "levelName", $$v)
                      },
                      expression: "editForm.levelName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "累计消费门槛(元)" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0, precision: 2 },
                    model: {
                      value: _vm.editForm.consumeThreshold,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "consumeThreshold", $$v)
                      },
                      expression: "editForm.consumeThreshold",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "直推奖比例(%)" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0, max: 100, precision: 2 },
                    model: {
                      value: _vm.editForm.bonusRate,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "bonusRate", $$v)
                      },
                      expression: "editForm.bonusRate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "是否展示" } },
                [
                  _c("el-switch", {
                    attrs: { "active-value": true, "inactive-value": false },
                    model: {
                      value: _vm.editForm.isShow,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "isShow", $$v)
                      },
                      expression: "editForm.isShow",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.editDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.handleSaveConfig },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "box-card mt14" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [_c("span", [_vm._v("用户等级列表")])]
          ),
          _c(
            "el-tabs",
            {
              on: {
                "tab-click": function ($event) {
                  return _vm.getUserList(1)
                },
              },
              model: {
                value: _vm.userActiveZone,
                callback: function ($$v) {
                  _vm.userActiveZone = $$v
                },
                expression: "userActiveZone",
              },
            },
            [
              _c("el-tab-pane", {
                attrs: { label: "企业活动专区", name: "1" },
              }),
              _c("el-tab-pane", {
                attrs: { label: "商家赋能专区", name: "2" },
              }),
            ],
            1
          ),
          _c(
            "el-form",
            { staticClass: "mb14", attrs: { inline: "", size: "small" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "手机号" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "160px" },
                    attrs: { placeholder: "手机号", clearable: "" },
                    model: {
                      value: _vm.userSearch.phone,
                      callback: function ($$v) {
                        _vm.$set(_vm.userSearch, "phone", $$v)
                      },
                      expression: "userSearch.phone",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "用户UID" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "150px" },
                    attrs: { placeholder: "用户UID", clearable: "" },
                    model: {
                      value: _vm.userSearch.uid,
                      callback: function ($$v) {
                        _vm.$set(_vm.userSearch, "uid", $$v)
                      },
                      expression: "userSearch.uid",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.getUserList(1)
                        },
                      },
                    },
                    [_vm._v("搜索")]
                  ),
                  _c("el-button", { on: { click: _vm.handleResetUser } }, [
                    _vm._v("重置"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.userLoading,
                  expression: "userLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.userList.data,
                size: "mini",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "60" },
              }),
              _c("el-table-column", {
                attrs: { prop: "uid", label: "用户UID", width: "100" },
              }),
              _c("el-table-column", {
                attrs: { prop: "nickname", label: "用户昵称", width: "120" },
              }),
              _c("el-table-column", {
                attrs: { prop: "phone", label: "手机号", width: "120" },
              }),
              _c("el-table-column", {
                attrs: { prop: "level", label: "等级", width: "80" },
              }),
              _c("el-table-column", {
                attrs: { prop: "levelName", label: "等级名称", width: "120" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "cumulativeConsume",
                  label: "累计消费",
                  width: "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "levelUpTime",
                  label: "最近升级时间",
                  "min-width": "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  "min-width": "150",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [20, 40, 60],
                  "page-size": _vm.userSearch.limit,
                  "current-page": _vm.userSearch.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.userList.total,
                  background: "",
                },
                on: {
                  "size-change": _vm.handleUserSizeChange,
                  "current-change": _vm.userPageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }